import produce from "immer";
import {ACTION_TYPE} from "utils/constants";
const {CHANGE_AD_USED_STATE, CHANGE_AD_SHOW_STATE, CHANGE_AD_POSITION} =
  ACTION_TYPE;

const initialState = {
  "320_100": {
    isUsed: false,
    isShow: false,
    x: 0,
    y: 0,
  },
  "320_200": {
    isUsed: false,
    isShow: false,
    x: 0,
    y: 0,
  },
  "320_500": {
    isUsed: false,
    isShow: false,
    x: 0,
    y: 0,
  },
  "400_400": {
    isUsed: false,
    isShow: false,
    x: 0,
    y: 0,
  },
  "800_120": {
    isUsed: false,
    isShow: false,
    x: 0,
    y: 0,
  },
};

const ad = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_AD_USED_STATE:
      return produce(state, draft => {
        draft[action.size] = {
          ...state[action.size],
          isUsed: action.bool,
        };
      });
    case CHANGE_AD_SHOW_STATE:
      return produce(state, draft => {
        draft[action.size] = {
          ...state[action.size],
          isShow: action.bool,
        };
      });
    case CHANGE_AD_POSITION:
      return produce(state, draft => {
        draft[action.size] = {
          ...state[action.size],
          x: action.x,
          y: action.y,
        };
      });
    default:
      return state;
  }
};

export default ad;
